import {
  memo,
  useEffect,
  useContext
} from 'react';

import { JobFormControllerContext } from 'lib/oneflare-job-form/utils/context';

type GetFreeQuotesProps = {
  isIframe?: boolean;
};

const GetFreeQuotes = ({
  isIframe = false
}: GetFreeQuotesProps) => {
  const { controller } = useContext(JobFormControllerContext);
  useEffect(() => {
    if (isIframe) {
      setTimeout(() => {
        window.parent.postMessage('job-form-is-mounted', '*');
      }, 300);
    }
  }, [isIframe]);

  useEffect(() => {
    const messageListener = (event) => {
      const options = event.data;
      const categoryId = options.categoryId || 0;
      const locationId = options.locationId || 0;
      const locationName = options.locationPrefill || '';
      const partnerLogo = options.partnerLogo || '';
      const source = options.source || '';
      const externalSource = !!(options.external || source.indexOf('oneflare') === -1);
      const redirectOnSuccess = !!(externalSource && options.redirectOnSuccess || options.redirectOnSuccess);

      switch (event.data.type) {
        case 'open-job-form':
          // specify that job form is being rendered through and iframe
          controller.state.external.next({
            isIframe: true,
            redirectOnSuccess,
            partnerLogo
          });
          
          // open job form
          controller.open({
            categoryId,
            locationId,
            locationName
          });
          break;
        case 'tracking-job-form':
          console.info('Tracking:', window.dataLayer);
          break;
        default:
          break;
      }
    };

    if (isIframe) {
      window.addEventListener('message', messageListener);
      window.history.pushState(null, null);
    }

    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, [controller, isIframe]);

  return null;
};

export default memo(GetFreeQuotes);
